import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { MetropolisLogoWordmark, Person } from '@m/icons';

import { Button } from '@m/components-ui/button';

export interface MarketingHeaderProps {
  aboutHref: string;
  getTheAppHref: string;
  /** When set, shows the Log in or sign up CTA. */
  signInHref?: string;
}

const navLinkStyles = {
  textDecoration: 'none',
  color: 'text.primary',
  _hover: { color: 'text.link.hover', textDecoration: 'none' },
  _active: { color: 'text.link.active' },
} as const;

export const MarketingHeader = ({ aboutHref, getTheAppHref, signInHref }: MarketingHeaderProps) => (
  <Box
    as="nav"
    bg="fill.background.default"
    borderBottom="1px solid"
    borderColor="stroke.divider.default"
    minH={{ md: '72px' }}
    px={{ base: '16px', md: '40px' }}
    py={{ base: '12px', md: '16px' }}
    width="full"
  >
    <Flex align="center" justify="space-between" gap={{ base: '4', md: '6' }}>
      <Box flexShrink={0} color="text.primary" lineHeight={0}>
        <Link href="/" aria-label="Metropolis home" display="inline-flex">
          <MetropolisLogoWordmark width={148} height={34} />
        </Link>
      </Box>

      <Flex align="center" gap={{ base: '4', md: '6' }} justify="flex-end" wrap="wrap" width="auto">
        <Link href={aboutHref} target="_blank" rel="noopener noreferrer" {...navLinkStyles}>
          <Text variant="SmallBodyMedium">About</Text>
        </Link>
        <Link href={getTheAppHref} target="_blank" rel="noopener noreferrer" {...navLinkStyles}>
          <Text variant="SmallBodyMedium">Get the app</Text>
        </Link>
        {signInHref && (
          <Button asChild variant="secondary" size="md">
            <a href={signInHref} rel="noopener noreferrer" target="_blank">
              <Person aria-hidden />
              Log in or sign up
            </a>
          </Button>
        )}
      </Flex>
    </Flex>
  </Box>
);
